let _ = require('../_.js');
let $ = jQuery;

_.My_Auctions_Modal = class My_Auctions_Modal {

    static init() {
        _.on_ui_update_once(".my-auctions-link", function () {
            $(this).click(async function (e) {
                e.preventDefault();
                
                await _.Login_From_Header.handle_with_page_init('my-auctions', async () => {
                    await _.Login_From_Header.await_for_session();
                    _.Login_From_Header.close_header();
                    
                    // Close mobile menu if open
                    $(".header-new-mobile .header-menu").removeClass("header-menu-open");
                    
                    _.My_Auctions_Modal.show();
                });
            });
        });
    }

    static async show() {
        // Get the modal element
        let $modal = $("#modal-my-auctions");
        
        // Show the modal
        $modal.modal_show();
        
        // Load auctions after modal is shown
        await _.My_Auctions_Modal.loadAuctions();
    }

    static async loadAuctions() {
        // Get the modal element
        let $modal = $("#modal-my-auctions");
        
        $modal.find(".auctions-are-loading").show();
        $modal.find(".there-are-no-auctions").hide();
        $modal.find(".auctions-upcoming").hide();
        $modal.find(".auctions-past").hide();

        try {
            // Get auctions data from backend - this already returns the 'return' value
            let auction_data = await _.backend_ajax('auctions', 'my_auctions_unified');
            
            // Debug log
            console.log('My Auctions data:', auction_data);

            if (!auction_data || !Array.isArray(auction_data) || auction_data.length === 0) {
                // No auctions found - show empty state
                $modal.find(".auctions-are-loading").hide();
                $modal.find(".there-are-no-auctions").show();
                return;
            }

            // Track found IDs for cleanup later
            let upcoming_found_ids = [];
            let past_found_ids = [];

            // Separate auctions into past and upcoming based on status
            // Past auctions: STATUS_COMPLETE (1) or STATUS_CONTRACT (2)
            let pastAuctions = auction_data.filter(auction => 
                auction.status === 1 || auction.status === 2
            );
            let upcomingAuctions = auction_data.filter(auction => 
                auction.status !== 1 && auction.status !== 2
            );

            // Debug log
            console.log('Upcoming auctions:', upcomingAuctions.length, upcomingAuctions);
            console.log('Past auctions:', pastAuctions.length, pastAuctions);

            // Get table containers
            let $upcomingTableContainer = $modal.find(".auctions-upcoming-table tbody");
            let $pastTableContainer = $modal.find(".auctions-past-table tbody");

            // Populate upcoming auctions table
            if (upcomingAuctions.length > 0) {
                $modal.find(".auctions-upcoming").show();
                
                upcomingAuctions.forEach(auction => {
                    upcoming_found_ids.push(auction.id);
                    this.addAuctionRow($upcomingTableContainer, auction);
                });
            }

            // Populate past auctions table
            if (pastAuctions.length > 0) {
                $modal.find(".auctions-past").show();
                
                pastAuctions.forEach(auction => {
                    past_found_ids.push(auction.id);
                    this.addAuctionRow($pastTableContainer, auction);
                });
            }

            // Remove any rows that shouldn't be there anymore
            $upcomingTableContainer.remove_unlisted_components(upcoming_found_ids);
            $pastTableContainer.remove_unlisted_components(past_found_ids);

            // Hide loading indicator
            $modal.find(".auctions-are-loading").hide();

            // If no auctions in either category, show empty state
            if (upcomingAuctions.length === 0 && pastAuctions.length === 0) {
                $modal.find(".there-are-no-auctions").show();
            }

        } catch (error) {
            console.error('Error loading auctions:', error);
            $modal.find(".auctions-are-loading").hide();
            $modal.find(".there-are-no-auctions").text('Error loading auctions. Please try again.').show();
        }
    }

    static addAuctionRow($tableContainer, auction) {
        // Create or get component using the auction ID
        let $component = $tableContainer.component(auction.id, "default", {
            direction: 'desc'  // Most recent first
        });

        // Format the date (handle null auctioncast_date)
        let formattedDate = 'TBD';
        if (auction.auctioncast_date) {
            let date = new Date(auction.auctioncast_date);
            formattedDate = date.toLocaleDateString('en-US', {
                month: '2-digit',
                day: '2-digit', 
                year: 'numeric'
            });
        }

        // No longer using role column - will be merged with status

        // Format location for mobile
        let locationText = auction.address || 'N/A';
        if (locationText.length > 30) {
            // Extract city and state if possible
            let parts = locationText.split(',');
            if (parts.length >= 2) {
                locationText = parts[parts.length - 2].trim() + ', ' + parts[parts.length - 1].trim();
            }
        }

        // Populate row data - no link in property column anymore
        $component.find('.ac-modal-bidhistory-table-row-property').text(auction.title);
        $component.find('.ac-modal-bidhistory-table-row-location').text(locationText);
        $component.find('.ac-modal-bidhistory-table-row-acres').text(auction.acres || 'N/A');
        $component.find('.ac-modal-bidhistory-table-row-date').text(formattedDate);
        
        // Build status HTML with all relevant badges
        let statusHtml = `<span class="badge ${auction.status_badge_frontend}">${auction.status_label_frontend}</span>`;
        
        // Add role/status badges
        if (auction.is_manager) {
            statusHtml += ' <span class="badge badge-info" style="margin-left: 5px;">Manager</span>';
        } else if (auction.registration_pending && auction.status_label_frontend !== 'Registration Pending') {
            statusHtml += ' <span class="badge badge-warning" style="margin-left: 5px;">Reg. Pending</span>';
        } else if (auction.won_items_count > 0) {
            statusHtml += ` <span class="badge badge-success" style="margin-left: 5px;">Won ${auction.won_items_count} Item${auction.won_items_count > 1 ? 's' : ''}</span>`;
        }
        
        $component.find('.ac-modal-bidhistory-table-row-status').html(statusHtml);
        
        // Add click handler to the entire row
        $component.off('click').on('click', function(e) {
            e.preventDefault();
            window.open(auction.frontend_url, '_blank');
        });
    }
}